import { AppPageLayout } from "@/components/common/AppPageLayout";
import { CompletionShell } from "@/components/pages/SuccessPage";
import { publicFormRoutePaddingClass } from "@/features/pages/components/formPageLayout";
import { useScreenerCopy } from "@/features/i18n/screenerCopy";
import { Unlink } from "lucide-react";

/** A wrong link or a screener that has been switched off. */
function ScreenerUnavailable() {
    const copy = useScreenerCopy();
    return (
        <AppPageLayout width="md" padding="sm" className={publicFormRoutePaddingClass}>
            <CompletionShell title={copy.notFoundTitle} description={copy.notFoundBody} icon={Unlink} pinFooter />
        </AppPageLayout>
    );
}

export default ScreenerUnavailable;
